import {
  OPEN_SEARCHBOX_MODAL,
  CLOSE_SEARCHBOX_MODAL
} from "../constants/actionTypes";
import initialState from "./initialState";

export const searchBoxModalOpenReducer = (
  state = initialState.isSearchboxModalOpen,
  action
) => {
  switch (action.type) {
    case OPEN_SEARCHBOX_MODAL:
      return true;
    case CLOSE_SEARCHBOX_MODAL:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/generalReducers.js